import RPC from './server'

export default function Validators(validator) {
/*
  validator.extend('password', {
      getMessage: field => `${field} must have 6 to 15 characters and contain 1 uppercase letter and 1 digit.`,
      validate: value => {
        return /^(?=.*[A-Z])(?=.*[0-9])(?=.{6,15}$)/.test(value);

      }
    }) // Password

  validator.extend('loginname', {
      getMessage: field => `${field} must have 6 to 20 characters.Can contain A-Z, a-z and 0-9.`,
      validate: value => {
        return /^[a-zA-Z0-9]{6,20}$/.test(value);
      }
    }) // Loginin name

  validator.extend('verifylogin', {
      getMessage: field => `${field} already exists. Try a differnt ${field}`,
      validate: value =>
        new Promise(resolve => {
          RPC({
              method: "user.checkuser",
              args: {
                ln: value
              }
            }).then((data) => {
              resolve({
                valid: data.valid
              })
            })
            .catch(err => {
              resolve({
                valid: false
              })
            })

        })

    }) // Unique Loginin name

*/

  validator.extend('verifyemail', {
      getMessage: field => `${field} already exists. Try a differnt ${field}`,
      validate: (value,[args]) =>
      {
              
        return new Promise(resolve => {
          RPC({
              method: "user.emailcheck",
              args: args ? {e: value, cId:args } : {e: value}
            }).then((data) => {
              resolve({
                valid: data.valid
              })
            })
            .catch(err => {
              console.log(err);
              resolve({
                valid: false
              })
            })

        }) 
      }
    }) // Unique Email name


/*
  validator.extend('terms', {
      getMessage: field => 'You must agree with terms and conditions.',
      validate: value => {
        return value
      }
    }) // Loginin name
*/
}



// WEBPACK FOOTER //
// ./src/modules/validators.js